import i18n from "i18next";
import axios from "axios";
import { store } from "../../store/store-config";
import { GlobalTypes } from "../../store/global-types";
import { AuthActionTypes } from "../../store/auth/auth-types";
import { action } from "typesafe-actions";

const talentApi = axios.create({
  baseURL: process.env.REACT_APP_TALENT_API_URL,
});

talentApi.interceptors.request.use((config) => {
  const state = store.getState();
  const hasState = state.authState.token;
  if (hasState) {
    config.headers.Authorization = `Bearer ${state.authState.token}`;
  }

  config.headers.Language = i18n.language || "pt-BR";

  return config;
});

talentApi.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response.status === 401) {
      store.dispatch({ type: GlobalTypes.LOGOUT });
      store.dispatch({ type: GlobalTypes.CLEAR });
    }
    if (error.response.status === 403) {
      store.dispatch(action(AuthActionTypes.FETCH_SHOW_ACCOUNT_CONFIRMATION_MODAL, { by_action: true }));
    }
    return Promise.reject(error);
  }
);

export default talentApi;
